import create from 'zustand';
import { persist } from 'zustand/middleware';

import { CPData } from '@models/store/cpStore';
import { getCPById, getCPByInsurance } from '@api/getCP';

interface CPInitialData {
  zip_code: string;
  state_code: string;
  state_name: string;
  suburb_code: string;
  suburb_name: string;
  city_name: string;
  township_code: string;
  township_name: string;
}

export const initialCPData: CPInitialData = {
  zip_code: '72000',
  state_code: '999999666666',
  state_name: 'Puebla',
  suburb_code: '0001',
  suburb_name: 'Centro',
  city_name: 'Heroica Puebla de Zaragoza',
  township_code: '114',
  township_name: 'Puebla',
};

interface CP {
  cpData: CPData[];
  searchCP: (id: string, token: string) => void;
  searchCPInsurance: (id: string, insurance: string, token: string) => CPData;
}

export const useCPStore = create<CP>(
  //@ts-ignore
  persist(
    (set) => ({
      cpData: [],
      searchCP: async (id, token) => {
        const cp = await getCPById(id, token);
        set({ cpData: cp ? cp : [] });
      },
      searchCPInsurance: async (id, insurance, token) => {
        const cp = await getCPByInsurance(id, insurance, token);
        set({ cpData: cp || [] });
        return cp;
      },
    }),
    {
      name: 'cp-storage',
      getStorage: () => sessionStorage,
    }
  )
);
